<template>
  <div class="record">
    <div v-if="showEmpty">
      <van-empty description="暂无答题记录~" />
    </div>
    <van-list
      v-model="loading"
      :error.sync="error"
      :finished="finished"
      finished-text="没有更多了"
      error-text="请求失败，点击重新加载"
      @load="onLoad"
    >
      <div class="record-item" v-for="(item, index) in questionList" :key="index">
        <div class="date">
          <div class="cirle" :class="'cirle' + item.status">
            <div class="line" :class="'line' + item.status"></div>
          </div>
          <div class="time" :class="'time' + item.status">{{ item.commitTime | fmtTime }}</div>
        </div>
        <div class="info">
          <div class="name van-ellipsis">{{ item.name }}</div>
          <div class="status" :class="'status' + item.status">{{ item.status | status }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { getListByUid } from '../../api/anser'
import store from '../../store/index'
import { formatTime } from '../../util/index'
export default {
  created() {
    const userInfo = store.getters.userInfo
    if(userInfo) {
      this.id = userInfo.user.id
      // this.getQuestionList()
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      error: false,
      questionList: [],
      id: '',
      showEmpty: false,
      config: {
        pageNum: 0,
        pageSize: 10
      }
    }
  },
  methods: {
    getQuestionList() {
      getListByUid({
        pageNum: 1,
        pageSize: 300, // 不分页，所以暂时设置300 后续超出需增加
        uid: this.id
      }).then(res => {
        if(res.data.list.length === 0) {
          this.showEmpty = true
          return
        }
        this.questionList = res.data.list
      })
    },
    async onLoad() {
      this.config.pageNum +=1
      let res = await getListByUid({ ...this.config, uid: this.id })
      const list1 = res.data.list
      this.questionList = this.questionList.concat(list1)
      this.loading = false
      if (res.data.isLastPage) {
        this.finished = true
      }
    },
  },
  filters: {
    status(val) {
      if (Number(val) === 0 ) {
        return '待审核'
      }
      if (Number(val) === 1 ) {
        return '已通过'
      }
      if (Number(val) === 2 ) {
        return '已拒绝'
      }
      if (Number(val) === 3 ) {
        return '待审核'
      }
      if (Number(val) === 4 ) {
        return '已通过'
      }
    },
    fmtTime(val) {
      const res = formatTime(val)
      return `${res.year}/${res.month}/${res.day}   ${res.hour}:${res.minute}:${res.second}`
    }
  }
}
</script>

<style lang="stylus">
  .record {
    min-height: 100vh;
    background: #F2F2F2;
    padding: 30px;
    .record-item {
      position: relative;
      padding: 45px 0 45px 30px;
      .date {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        .cirle {
          width: 26px;
          height: 26px;
          border: 4px solid #368BFF;
          border-radius: 50%;
          position: relative;
          .line{
            position: absolute;
            height: 100px;
            width: 1PX;         
            background: #368BFF;
            bottom: -102px;
            left: 13px
          }
          .line1 {
            background: #888888;
          }
          .line2 {
            background: #E20000;
          }
          .line3 {
            background: #368BFF;
          }
          .line4 {
            background: #888888;
          }
        }
        .cirle1 {
          border: 2Px solid #888888;
        }
        .cirle2 {
          border: 2Px solid #E20000;
        }
        .cirle3 {
          border: 2Px solid #368BFF;
        }
        .cirle4 {
          border: 2Px solid #888888;
        }
        .time {
          margin-left: 18px;
          color: #368BFF;
          font-size: 20px;
        }
        .time1{
          color: #888888;
        }
        .time2{
          color: #E20000;
        }
        .time3{
          color: #368BFF;
        }
        .time4{
          color: #888888;
        }
      }
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          width: 460px;
          margin-left: 20px;
          font-size: 30px;
          font-weight: bold;
          color: #333333;
          padding: 35px 30px;
          background: #FFFFFF;
          box-shadow: 0px 0px 24px 0px rgba(0, 56, 112, 0.1);
          border-radius: 0px 10px 10px 10px;
        }
        .status {
          color: #368BFF;
          font-size: 20px;
          flex: 1 1 auto;
          text-align: right;
        }
        .status1{
          color: #888888;
        }
        .status2{
          color: #E20000;
        }
        .status3{
          color: #368BFF;
        }
        .status4{
          color: #888888;
        }
      }
    }
  }
</style>